"use client";

import { motion } from "framer-motion";
import { Rocket, Coins, Sparkles, ArrowUpCircle } from "lucide-react";
import { ReactNode } from "react";

interface ActionButton {
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  variant: "primary" | "secondary";
  disabled?: boolean;
}

interface UpgradeRequiredCardProps {
  title: ReactNode;
  message: string;
  actions: ActionButton[];
}

export function UpgradeRequiredCard({
  title,
  message,
  actions,
}: UpgradeRequiredCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="w-full max-w-md"
    >
      <div className="relative rounded-xl border border-white/[0.08] bg-white/[0.02] overflow-hidden">
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-emerald-400/30 to-transparent" />

        <div className="px-5 py-4 space-y-3">
          <p className="text-sm font-semibold text-white tracking-tight">{title}</p>
          <p className="text-[13px] text-white/90 leading-relaxed">{message}</p>

          <div className="flex gap-2 pt-0.5">
            {actions.map((action, i) => (
              <button
                key={i}
                onClick={action.onClick}
                disabled={action.disabled}
                className={`group inline-flex items-center gap-2 justify-center px-4 py-1.5 text-[13px] font-medium rounded-md
                  transition-all duration-200 flex-1 disabled:opacity-60 disabled:cursor-not-allowed ${
                    action.variant === "primary"
                      ? "bg-white hover:bg-white/90 text-black"
                      : "bg-transparent hover:bg-white/[0.06] text-white border border-white/[0.16]"
                  }`}
              >
                {action.icon}
                {action.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export { Rocket, Coins, Sparkles, ArrowUpCircle };
